module.exports = __webpack_public_path__ + "static/media/legitel.50cd61d2.jpg";